import { Component, Fragment, VNode } from 'vue';

function isVNodeArray(value: unknown): value is VNode[] {
    return Array.isArray(value) && value.every((item) => item && typeof item === 'object');
}

export function flattenVNodes(vnodes: VNode[] | undefined): VNode[] {
    const result: VNode[] = [];

    if (!vnodes) return result;

    const flatten = (nodes: VNode[]): void => {
        nodes.forEach((vnode) => {
            if (!vnode) {
                return;
            }

            if (vnode.type === Fragment && isVNodeArray(vnode.children)) {
                flatten(vnode.children);
                return;
            }

            result.push(vnode);
        });
    };

    flatten(vnodes);

    return result;
}

export function isVNodeOfComponent<P = Record<string, unknown>>(
    vnode: VNode,
    component: Component,
): vnode is VNode & { props: P } {
    return vnode.type === component;
}

export function filterVNodesByComponent<P = Record<string, unknown>>(
    vnodes: VNode[],
    component: Component,
): Array<VNode & { props: NonNullable<P> }> {
    return vnodes.filter(
        (vnode): vnode is VNode & { props: NonNullable<P> } =>
            isVNodeOfComponent(vnode, component) && vnode.props != null,
    );
}
